import { useMemo } from "react";

import { useAppSelector } from "@/redux/hooks";
import { listSelector } from "@/pages/Private/redux/list/list.slice";
import { useGetPendingLeadScoringQuery } from "@/pages/Private/redux/score/scoringPending.api";
import {
	PENDING_LEAD_SCORING_POLL_MS,
	toPendingLeadRows,
} from "@/pages/Private/redux/score/scoring-pending.helper";

/**
 * Whether this lead's scoring is still queued (PREC-4076).
 *
 * Every score cell on the page calls this with the same arguments, so RTK Query serves them all
 * from one cache entry and one poll — there is deliberately no context provider and nothing to
 * mount. The rows come from the list slice's `inbox`, which is what the table is rendering.
 */
export const useIsScoringPending = (listId: number | undefined, listPersonId: number): boolean => {
	const inbox = useAppSelector(listSelector).inbox;
	const leads = useMemo(() => toPendingLeadRows(inbox), [inbox]);

	const { data } = useGetPendingLeadScoringQuery(
		{ listId: listId ?? 0, leads },
		{
			skip: !listId || !leads.length,
			pollingInterval: PENDING_LEAD_SCORING_POLL_MS,
		}
	);

	return !!data?.listPersonIds.includes(listPersonId);
};
